import React from "react";

export default function(event, handler, Component) {
  var klass = class Pure extends React.Component {
    constructor(props) {
      super(props);
      this.handleEvent = this.handleEvent.bind(this);
    }

    componentDidMount() {
      document.addEventListener(event, this.handleEvent);
    }

    componentWillUnmount() {
      document.removeEventListener(event, this.handleEvent);
    }

    handleEvent(e) {
      handler(e, this.props);
    }

    render() {
      return <Component {...this.props} />;
    }
  };
  klass.displayName = "OnDocumentEvent(" + Component.name + ")"; // eslint-disable-line react/static-property-placement
  return klass;
}

